import React, { useCallback, useMemo } from 'react'
import { Point } from '@aytm/app/insights/dashboard/components/ui'
import mcss from './ReassignSigTest.module.scss'
import { useDashboard } from '@aytm/app/insights/dashboard/components/hooks'
import { BLOCK_TYPES, isRowAveragesUid } from '@aytm/app/insights/dashboard/lib/config'
import { poolDispatch } from '@aytm/app/insights/dashboard/duckness/poolDispatch'
import { makeReassignSigTestLettersAction } from '@aytm/app/insights/dashboard/duckness/ducks/EventDuck/EventDuck.actionCreators'

export const ReassignSigTestLetters: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
  const { blockModel } = useDashboard()

  const blockItems = useMemo(() => blockModel?.getBlockItems(), [blockModel])

  const items = useMemo(() => blockItems?.toJS() || [], [blockItems])

  const effectiveDisabled = useMemo(
    () => disabled || !items.length || (1 === items.length && isRowAveragesUid(items[0].uid)),
    [disabled, items]
  )

  const isTracker = blockModel?.type === BLOCK_TYPES.TRACKING_VALUES

  const handleReassignSigTestLetters = useCallback(() => {
    poolDispatch(makeReassignSigTestLettersAction())
  }, [])

  return (
    <div className={mcss['reassign-sig-test-letters']}>
      <button
        type="button"
        onClick={handleReassignSigTestLetters}
        className={mcss[`reassign-sig-test-letters-label`]}
        disabled={effectiveDisabled}
      >
        {'Clean up SigTest letters'}
      </button>
      <Point
        className={mcss[`reassign-sig-test-letters-point`]}
        tipName={isTracker ? 'regenSigTestLettersWaves' : 'regenSigTestLetters'}
      />
    </div>
  )
}
